import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_WEB_API;
const API_Payment_URL = process.env.REACT_APP_PAYMENT_API;

export const GetPolicies = async (cpr, setIsLoading) => {
    const url = `${API_BASE_URL}policy/GetPolicies`;
    const data = {
      Cpr: cpr,
      Channel: "",
    };
    setIsLoading(true);

    //var token = tokenDetails.access_token;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        throw new Error("Failed to retrieve policy details");
      }

      const result = await response.json();
      setIsLoading(false);
      return result;
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.error("Error", error);
    }
  };


  export const CheckPlan = async (PolicyNumber, setIsLoading) => {
    const url = `${API_BASE_URL}Sbdrive/CheckPlan`;
    const data = {
      PolicyNumber: PolicyNumber,
    };
    setIsLoading(true);

    //var token = tokenDetails.access_token;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.Message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        setIsLoading(false);
        return errorDetails;
      }

      const result = await response.json();
      setIsLoading(false);
      return result;
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.error("Error", error);
    }
  };


  export const ExpirePlan = async (PolicyNumber, setIsLoading) => {
    const url = `${API_BASE_URL}Sbdrive/ExpirePlan`;
    const data = {
      PolicyNumber: PolicyNumber,
    };
    setIsLoading(true);

    var tokenDetails = await getToken();
    var token = tokenDetails.access_token;
    try {
      const response = await fetch(url, {
        method: "POST",
       headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // Add Bearer token here
      },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.Message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        setIsLoading(false);
        return errorDetails;
      }

      const result = await response.json();
      setIsLoading(false);
      return result;
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.error("Error", error);
    }
  };

 export const getToken = async () => {
  const url = `${API_BASE_URL}token`;
  const body = "username=accountsdashboard&password=Acc@dash123"; // Replace with actual values

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch token");
    }

    const result = await response.json();
    return result.access_token; // Adjust key name if needed
  } catch (error) {
    console.error("Token Error:", error);
    return null;
  }
};


 export const CreateLog = async (UserName, UserAction, ActionType, ExtraInformation) => {
    const url = `${API_Payment_URL}Logs/CreateLog`;
    const data = {
      UserName: UserName,
      UserAction: UserAction,
      ActionType: ActionType,
      ExtraInformation: ExtraInformation,

    };
  
    try {
      const response = await fetch(url, {
        method: "POST",    
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.Message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        
        return errorDetails;
      }

      const result = await response.json();
     
      return result;
    } catch (error) {
      
      console.error("Error", error);
    }
  };
  